import queryString from 'qs';

export const getStudioRequest = (queryParams) => {
  const queries = { limit: queryParams?.limit, page: queryParams?.page };

  if (queryParams?.sort) queries.sort = `${queryParams?.sort?.field}.${queryParams?.sort?.order}`;
  if (queryParams?.area?.id) queries['area.id'] = queryParams?.area?.id;
  if (queryParams?.appType?.id) queries['appType.id'] = queryParams?.appType?.id;
  if (queryParams?.search) queries.search = queryParams?.search;

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getStudioRequest;
